import * as React from 'react';
import { Text } from '@gandi/ui';
import { jsx as _jsx } from "react/jsx-runtime";
export default function LongWordBreaker({
  children
}) {
  return /*#__PURE__*/_jsx(Text, {
    overflow: "break",
    children: children
  });
}